import { SVGProps, Ref, forwardRef } from 'react';

export const CompanysLifeFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15.5 4.755 11.4C1.204 11.266 0 9.84 0 5.955 0 1.864 1.333.5 5.333.5h5.334C14.667.5 16 1.864 16 5.955c0 3.886-1.203 5.31-4.752 5.444zm-.825-7.848a.47.47 0 0 1-.143-.32h-1.4c0 .502.209.945.522 1.279.45.48 1.127.754 1.844.754S9.39 9.09 9.84 8.61c.314-.334.523-.777.523-1.28h-1.4c0 .099-.039.21-.143.321-.158.168-.45.313-.823.313s-.665-.145-.823-.313m-1.51-4.42c-.461 0-.783.156-.988.401-.202.242-.278.56-.278.866s.076.624.278.866c.205.245.527.4.988.4.462 0 .784-.155.988-.4.202-.242.279-.56.279-.866 0-.307-.077-.624-.279-.866-.204-.245-.526-.4-.988-.4m4.666 0c-.462 0-.784.156-.988.401-.202.242-.279.56-.279.866s.077.624.279.866c.204.245.526.4.988.4s.783-.155.988-.4c.202-.242.278-.56.278-.866 0-.307-.076-.624-.278-.866-.205-.245-.527-.4-.988-.4"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
CompanysLifeFilledSize16Glyph.displayName = 'CompanysLifeFilledSize16Glyph';
